type WindowWithDataLayer = Window & {
    dataLayer: {
        event: string;
        page?: string;
        eventCategory?: string;
        eventAction?: string;
        eventValue?: number;
        eventLabel?: string;
        stockItemId?: number;
    }[];
};

declare const window: WindowWithDataLayer;

export const pageView = (url: string): void => {
    if (typeof window.dataLayer !== 'undefined') {
        window.dataLayer.push({
            event: 'pageView',
            page: url,
        });
    }
};

export const downloadEvent = (stockItemId: number): void => {
    if (typeof window.dataLayer !== 'undefined') {
        window.dataLayer.push({
            event: 'StockBlocks Event',
            eventCategory: 'Stock Item',
            eventAction: 'item_download',
            eventValue: stockItemId,
            eventLabel: window.location.pathname,
            stockItemId: stockItemId,
        });
    }
};
